import {Checkboxes, Chips, DataStatus, Separator} from 'platform/components';
import {HStack, VStack} from 'platform/foundation-tw';

import {intersection} from 'ramda';
import {isArray} from 'ramda-adjunct';

import {Nullish, suffixTestId, useOnMount} from 'shared/web';

import {quickFiltersConst} from '../../constants/quickFilters';
import {useChoiceFilter} from '../../hooks/useChoiceFilter';
import {useFilterOnChipsChange} from '../../hooks/useFilterOnChipsChange';
import {useLazyChoiceFilterOptions} from '../../hooks/useLazyChoiceFilterOptions';
import {EagFilterProps} from '../../types/EagFilterProps';

export type CheckboxFilterProps = EagFilterProps & {
  columnKey: string;
  quickFilters?: Array<{value: string; label: string}>;
};

const FILTER_VALUE_KEY = 'value';

export function CheckboxFilter(props: CheckboxFilterProps) {
  const rawModel = props.value[FILTER_VALUE_KEY] as string[] | string | Nullish;

  const [values, setValues] = useChoiceFilter({
    model: rawModel,
    onChange: (newValue) => {
      props.onChange({[FILTER_VALUE_KEY]: newValue});
    },
  });

  const {loadOptions, isLoading, options, errorMessage} = useLazyChoiceFilterOptions({
    columnKey: props.columnKey,
  });

  const {onChipsChange} = useFilterOnChipsChange({
    setFilterValue: setValues,
    defaultValue: null,
  });

  const isQuickFilterValue = intersection(isArray(values) ? values : [values], quickFiltersConst);
  const isControlDisabled = props.isDisabled;

  useOnMount(() => {
    void loadOptions();
  });

  return (
    <VStack>
      {props.quickFilters && props.quickFilters.length > 0 && (
        <>
          <HStack>
            <Chips
              isDisabled={props.isDisabled}
              value={isQuickFilterValue}
              options={props.quickFilters}
              onChange={onChipsChange}
              isMultiple={false}
              data-testid={suffixTestId('checkbox-filter-quickFilters', props)}
              isDeselectable
            />
          </HStack>
          <Separator />
        </>
      )}
      <DataStatus isLoading={isLoading}>
        <Checkboxes
          options={options}
          value={isArray(values) ? values : null}
          onChange={setValues}
          isDisabled={isControlDisabled}
          errorMessage={errorMessage}
          checkedIcon="navigation/check"
          data-testid={suffixTestId('checkbox-filter', props)}
        />
      </DataStatus>
    </VStack>
  );
}
